var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:(_vm.upgradeTooltip),expression:"upgradeTooltip"}],class:_vm.loading || !_vm.canExportCsv ? 'text-muted' : ''},[_vm._v(" "+_vm._s(_vm.text)+" "),(!_vm.canExportCsv)?_c('small',[_c('b-icon-lock-fill')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }